import { Get } from "../utils/api";
import { useQuery } from "react-query";
import { useAuth0 } from "@auth0/auth0-react";
import { User } from "../../types/api/User";
import { useNavigate } from "react-router-dom";

export default (enabled = true) => {
  const { getAccessTokenSilently } = useAuth0();
  return useQuery(
    [`user`],
    async () => {
      return await Get<User>(`/api/user/me`, await getAccessTokenSilently());
    },
    {
      onError: () => {},
      enabled: enabled,
    }
  );
};
